import { Component, Input, OnInit } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { FoodCostOverviewData } from '../../models/food-cost-view-model.model';
import { FoodCostTarget } from '@usf/ngrx-inventory';

@Component({
  selector: 'app-overview-tile',
  templateUrl: './overview-tile.component.html',
  styleUrls: ['./overview-tile.component.scss'],
})
export class OverviewTileComponent {
  @Input() overviewData: FoodCostOverviewData;
  @Input() platform: PlatformEnum;
  platformRef = PlatformEnum;
  targetRef = FoodCostTarget;
  constructor() {}
}
